export type ColumnEdited = {
  index: number;
  name: string;
};

export type ErrorData = {
  line: number;
  message: string;
};
export enum EditorVariant {
  Schema,
  Layout,
  Options,
}
export type ExpressionData = {
  line: number;
  content: string;
  editorVariant: EditorVariant;
};

export type ValidationExpression = {
  expression: string;
  message: string;
};
